var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-header-wrapper" },
        [
          _c("PageHeader", { attrs: { title: "My Content" } }),
          _c(
            "el-form",
            {
              staticClass: "filter-form filter-wrapper",
              attrs: { "label-position": "left" },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "select-date-range",
                  attrs: { label: "Please select date range" },
                },
                [
                  _c("el-date-picker", {
                    staticClass: "date-picker",
                    attrs: {
                      "value-format": "yyyy-MM-dd",
                      type: "daterange",
                      "start-placeholder": "Begin date",
                      "end-placeholder": "End date",
                    },
                    on: { change: _vm.onDateRangeChange },
                    model: {
                      value: _vm.dateRange,
                      callback: function ($$v) {
                        _vm.dateRange = $$v
                      },
                      expression: "dateRange",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticClass: "filter-actions" },
                  [
                    _c("el-input", {
                      directives: [
                        {
                          name: "debounce",
                          rawName: "v-debounce",
                          value: _vm.onSearch,
                          expression: "onSearch",
                        },
                      ],
                      attrs: {
                        "prefix-icon": "el-icon-search",
                        placeholder: "Search",
                        clearable: "",
                      },
                      on: { clear: _vm.onSearch },
                      model: {
                        value: _vm.searchVal,
                        callback: function ($$v) {
                          _vm.searchVal = $$v
                        },
                        expression: "searchVal",
                      },
                    }),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "role",
                            rawName: "v-role",
                            value: [2, 3, 5, 7, 9, 11, 13],
                            expression: "[2, 3, 5, 7, 9, 11,13]",
                          },
                        ],
                        attrs: { type: "primary", icon: "el-icon-plus" },
                        on: {
                          click: function ($event) {
                            return _vm.openPaperDialog()
                          },
                        },
                      },
                      [_vm._v(" New Content ")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              ref: "table",
              attrs: {
                data: _vm.tableData,
                "element-loading-text": "Loading...",
              },
              on: {
                "sort-change": _vm.onSortChange,
                select: _vm.handleSelect,
                "select-all": _vm.handleSelectionAll,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "45", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "FileName",
                  label: "Content Name",
                  sortable: "custom",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: row.AttachmentPath,
                              target: "_blank",
                            },
                          },
                          [_vm._v(_vm._s(row.FileName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "CategoryName",
                  label: "Category",
                  sortable: "custom",
                  "min-width": "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "LevelName",
                  label: "Security Level",
                  sortable: "custom",
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "CreatedOn",
                  label: "Create Date",
                  sortable: "custom",
                  "filter-multiple": "",
                  formatter: _vm.rowDateFormatter,
                  "min-width": "135",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "NoPush",
                  label: "No.Push",
                  sortable: "custom",
                  "min-width": "110",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "UvIsRead",
                  label: "UV.Is Read",
                  sortable: "custom",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "RateOfHits",
                  label: "Rate of hits",
                  sortable: "custom",
                  "min-width": "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "NoDownloads",
                  label: "No.Downloads",
                  sortable: "custom",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "UvDuration",
                  label: "UV.Duration(s)",
                  sortable: "custom",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  label: "Operation",
                  align: "center",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "OptionMenu",
                          {
                            attrs: {
                              icon: "iconfont icon-more-menu",
                              iconSize: "18",
                            },
                          },
                          [
                            _c("OptionMenuItem", {
                              attrs: { icon: "el-icon-edit", title: "Edit" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleEdit(row)
                                },
                              },
                            }),
                            _c("OptionMenuItem", {
                              directives: [
                                {
                                  name: "role",
                                  rawName: "v-role",
                                  value: [2, 3, 5, 7, 9, 11, 13],
                                  expression: "[2, 3, 5, 7, 9, 11,13]",
                                },
                              ],
                              attrs: {
                                icon: "el-icon-delete",
                                title: "Delete",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDeletePaper(row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrap" },
            [
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "role",
                          rawName: "v-role",
                          value: [2, 3, 5, 7, 9, 11, 13],
                          expression: "[2, 3, 5, 7, 9, 11,13]",
                        },
                      ],
                      attrs: {
                        type: "text",
                        icon: "el-icon-delete",
                        size: "medium",
                        disabled: _vm.multipleSelection.length === 0,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleDeletePapers()
                        },
                      },
                    },
                    [_vm._v(" Delete Content(s) ")]
                  ),
                ],
                1
              ),
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": [10, 25, 50, 100],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("PaperDialog", {
        attrs: { visible: _vm.paperDialogVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.paperDialogVisible = $event
          },
          success: function ($event) {
            return _vm.onSuccess(true)
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
        },
      }),
      _c("NewPaperDialog2", {
        attrs: { visible: _vm.newPaperDialogVisible2 },
        on: {
          "update:visible": function ($event) {
            _vm.newPaperDialogVisible2 = $event
          },
          success: function ($event) {
            return _vm.onSuccess(true)
          },
        },
      }),
      _c("UploadContentDialog", {
        attrs: { visible: _vm.uploadContentDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.uploadContentDialogVisible = $event
          },
          success: function ($event) {
            return _vm.onSuccess(true)
          },
        },
      }),
      _c("ViewContentDialog", {
        attrs: { visible: _vm.viewDialogVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.viewDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
          success: _vm.onSuccess,
        },
      }),
      _c("UpdateContentDialog", {
        attrs: { visible: _vm.updateContentDialogVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.updateContentDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
          success: _vm.onSuccess,
        },
      }),
      _c("UpdatePaperDialog", {
        attrs: { visible: _vm.updatePaperDialogVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.updatePaperDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
          success: _vm.onSuccess,
        },
      }),
      _c("UpdateMeetingDialog", {
        attrs: { visible: _vm.updateMeetingDialogVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.updateMeetingDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
          success: _vm.onSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }